export default {
  // Común
  common: {
    confirm: 'Confirmar',
    cancel: 'Cancelar',
    save: 'Guardar',
    delete: 'Eliminar',
    edit: 'Editar',
    add: 'Agregar',
    search: 'Buscar',
    reset: 'Restablecer',
    export: 'Exportar',
    import: 'Importar',
    upload: 'Subir',
    download: 'Descargar',
    submit: 'Enviar',
    back: 'Atrás',
    next: 'Siguiente',
    previous: 'Anterior',
    close: 'Cerrar',
    refresh: 'Actualizar',
    loading: 'Cargando...',
    success: 'Operación exitosa',
    error: 'Operación fallida',
    warning: 'Advertencia',
    info: 'Información'
  },
  
  // Inicio de sesión
  login: {
    title: 'Inicio de Sesión',
    username: 'Nombre de usuario',
    password: 'Contraseña',
    login: 'Iniciar sesión',
    logout: 'Cerrar sesión',
    loginSuccess: 'Inicio de sesión exitoso',
    loginFailed: 'Inicio de sesión fallido',
    notLoggedIn: 'No ha iniciado sesión...',
    systemTitle: 'Tecnología Ambiental Qinghe · Sistema de Gestión de Generadores de Hidrógeno',
    welcomeTitle: 'Bienvenido - Sistema de Gestión de Generadores de Hidrógeno',
    usernameMinLength: 'El nombre de usuario debe tener al menos 2 caracteres',
    passwordFormat: 'Formato de contraseña inválido',
    verificationCode: 'Error de código de verificación (distingue mayúsculas y minúsculas)'
  },
  
  // Página de administración
  admin: {
    title: 'Tecnología Ambiental Qinghe - Administración',
    dashboard: 'Panel de control',
    menu: 'Menú',
    logout: 'Cerrar sesión'
  },
  
  // Gestión de dispositivos
  device: {
    title: 'Gestión de Dispositivos',
    list: 'Lista de Dispositivos',
    add: 'Agregar Dispositivo',
    edit: 'Editar Dispositivo',
    delete: 'Eliminar Dispositivo',
    status: 'Estado del Dispositivo',
    type: 'Tipo de Dispositivo',
    online: 'En línea',
    offline: 'Desconectado',
    heartbeat: 'Datos de Latido',
    record: 'Registro de Operación',
    activate: 'Registro de Activación',
    // 设备类型管理
    typeCode: 'Código de Tipo de Dispositivo',
    typeName: 'Nombre de Tipo de Dispositivo',
    selectOrganization: 'Por favor seleccione organización',
    typeCodePlaceholder: 'Por favor ingrese el código de tipo',
    typeNamePlaceholder: 'Por favor ingrese el nombre del tipo de dispositivo',
    typeCodeRequired: 'El código de tipo es obligatorio',
    typeNameRequired: 'El nombre del tipo es obligatorio',
    addType: 'Agregar Tipo',
    editType: 'Editar Tipo',
    deleteConfirm: '¿Está seguro de eliminar el tipo de dispositivo "{name}"?',
    deleteSuccess: 'Eliminado exitosamente',
    deleteFailed: 'Eliminación fallida',
    saveSuccess: 'Guardado exitosamente',
    saveFailed: 'Guardado fallido',
    getDataFailed: 'Error al obtener datos',
    organization: 'Organización',
    universal: 'Universal',
    defaultOutVol: 'Volumen de Salida Predeterminado (Minería)',
    outVolRequired: 'El volumen de salida predeterminado es obligatorio',
    changeRule: 'Regla de Cálculo de Cambio de Filtro',
    filterAlgorithm: 'Algoritmo de Filtro',
    byVolume: 'Por Volumen',
    byTime: 'Por Tiempo',
    none: 'Ninguno',
    ruleDescription: 'Regla de cálculo de cambio de filtro:',
    volumeRule: '1: Calcular por volumen (ej: filtros 1-4, cambiar cada 40000L)',
    timeRule: '2: Calcular por tiempo (ej: 1 año, 60000L)',
    validHot: 'Primera Agua Caliente',
    validHotYes: 'Sí',
    validHotNo: 'No',
    changeValue: 'Valor de Cambio de Filtro',
    changeValuePlaceholder: 'Por favor ingrese el valor de cambio de filtro',
    changeValueUnit: 'Unidad',
    changeValueUnitMl: 'ml',
    changeValueUnitYear: 'año',
    customSettings: 'Configuración Personalizada',
    settingKey: 'Clave',
    settingValue: 'Valor',
    settingRemark: 'Observación',
    settingKeyPlaceholder: 'Por favor ingrese la clave',
    settingValuePlaceholder: 'Por favor ingrese el valor',
    settingRemarkPlaceholder: 'Por favor ingrese la observación',
    addSettingRow: 'Agregar Fila',
    deleteSettingRow: 'Eliminar',
    relatedOrg: 'Organización Relacionada',
    remark: 'Observación'
  },
  
  // Gestión de organizaciones
  org: {
    title: 'Gestión de Organizaciones',
    list: 'Lista de Organizaciones',
    add: 'Agregar Organización',
    edit: 'Editar Organización',
    delete: 'Eliminar Organización',
    name: 'Nombre de la Organización',
    code: 'Código de la Organización',
    type: 'Tipo de Organización'
  },
  
  // Gestión de tarjetas de agua
  card: {
    title: 'Gestión de Tarjetas de Agua',
    list: 'Lista de Tarjetas de Agua',
    add: 'Agregar Tarjeta de Agua',
    bind: 'Vincular Tarjeta de Agua',
    unbind: 'Desvincular Tarjeta de Agua',
    import: 'Importar Tarjeta de Agua',
    export: 'Exportar Tarjeta de Agua',
    serialNo: 'Número de Serie',
    cardNo: 'Número de Tarjeta',
    status: 'Estado'
  },
  
  // Configuración del sistema
  setting: {
    title: 'Configuración del Sistema',
    general: 'Configuración General',
    security: 'Configuración de Seguridad',
    notification: 'Configuración de Notificaciones'
  },
  
  // Estadísticas de datos
  stats: {
    title: 'Estadísticas de Datos',
    tds: 'Estadísticas TDS',
    volume: 'Estadísticas de Volumen',
    usage: 'Estadísticas de Uso'
  },
  
  // Pie de página
  footer: {
    copyright: '© 2023 - Tecnología Ambiental Qinghe Co., Ltd. Todos los derechos reservados',
    icp: 'Registro ICP: ',
    techSupport: '© Soporte Técnico: Guangzhou Guanjun Hydrogen Technology Co., Ltd.'
  },
  
  // Mensajes de error
  error: {
    network: 'Error de Red',
    server: 'Error del Servidor',
    permission: 'Permisos Insuficientes',
    param: 'Error de Parámetro',
    notFound: 'Datos No Encontrados',
    pageNotFound: 'Lo siento, la página que visitó no existe'
  },
  
  // Menú relacionado
  menu: {
    // Gestión de Dispositivos
    equipment: 'Biblioteca de Equipos y Filtros',
    filterRecord: 'Registro de Cambio de Filtros',
    version: 'Biblioteca de Versiones Domésticas',
    dataQuery: 'Consulta de Datos TCP',
    heartbeat: 'Datos de Latido',
    singleUse: 'Datos de Uso Único',
    bindStats: 'Estadísticas de Vinculación',
    
    // Gestión de Clientes
    customer: 'Gestión de Clientes',
    agentCheck: 'Revisión de Agentes',
    agentProfit: 'Gestión de Beneficios de Agentes',
    promotionRoute: 'Configuración de Ruta de Promoción',
    partyType: 'Gestión de Tipo de Partido',
    
    // Consulta de Datos MQTT
    mqttQuery: 'Consulta de Datos MQTT',
    statusQuery: 'Consulta de Estado',
    outputRecord: 'Consulta de Registro de Salida',
    debug: 'Página de Depuración de Dispositivos',
    waterTotal: 'Consulta de Total de Agua',
    
    // Gestión del Sistema
    adminAccount: 'Cuenta de Administrador',
    deviceType: 'Gestión de Tipo de Dispositivo',
    defaultSettings: 'Configuración Predeterminada del Sistema',
    flowConfig: 'Personalización de Flujo de Agua',
    waterConfig: 'Configuración de Temperatura y Agua',
    businessLog: 'Registro de Negocios',
    
    // Gestión de Pagos
    payment: 'Gestión de Pagos',
    order: 'Gestión de Pedidos',
    statistics: 'Estadísticas de Datos',
    waterPrice: 'Configuración de Precio del Agua',
    recharge: 'Recarga'
  },

  // Gestión de Tipos de Parte
  orgLibConfig: {
    title: 'Gestión de Tipos de Parte',
    libName: 'Nombre de Parte',
    libNamePlaceholder: 'Por favor ingrese el nombre del tipo de parte',
    libLevel: 'Nivel de Parte',
    allLevels: 'Todos los Niveles',
    level: 'Nivel',
    typeId: 'ID de Tipo',
    typeName: 'Nombre de Tipo',
    typeNamePlaceholder: 'Por favor ingrese el nombre del tipo',
    typeLevel: 'Nivel de Tipo',
    parentType: 'Tipo Padre',
    childCount: 'Cantidad de Hijos',
    status: 'Estado',
    enabled: 'Habilitado',
    disabled: 'Deshabilitado',
    unknown: 'Desconocido',
    none: 'Ninguno',
    remark: 'Observación',
    remarkPlaceholder: 'Por favor ingrese una observación',
    createTime: 'Tiempo de Creación',
    detail: 'Detalle',
    edit: 'Editar',
    add: 'Agregar',
    delete: 'Eliminar',
    editType: 'Editar Tipo',
    addSubType: 'Agregar Subtipo',
    typeNameRequired: 'Por favor ingrese el nombre del tipo',
    typeLevelRequired: 'Por favor seleccione el nivel del tipo',
    deleteConfirm: '¿Está seguro de eliminar este tipo?',
    deleteSuccess: 'Eliminado exitosamente',
    deleteFailed: 'Error al eliminar',
    addSuccess: 'Agregado exitosamente',
    updateSuccess: 'Actualizado exitosamente',
    saveFailed: 'Error al guardar',
    getDataFailed: 'Error al obtener datos',
    getDetailFailed: 'Error al obtener detalle',
    getParentFailed: 'Error al obtener información del nodo padre',
    cannotEditRoot: 'El nodo raíz no se puede editar',
    cannotDeleteRoot: 'El nodo raíz no se puede eliminar',
    hasChildrenCannotDelete: 'Este nodo tiene hijos y no se puede eliminar',
    maxLevelReached: 'Se admite un máximo de 8 niveles'
  },

  // Gestión de Banner
  banner: {
    title: 'Gestión de Banner de Página de Inicio',
    addBanner: 'Agregar Banner',
    editBanner: 'Editar Banner',
    image: 'Imagen',
    linkUrl: 'URL de Enlace',
    sort: 'Ordenar',
    status: 'Estado',
    createTime: 'Tiempo de Creación',
    enabled: 'Habilitado',
    disabled: 'Deshabilitado',
    titlePlaceholder: 'Por favor ingrese el título del banner',
    titleRequired: 'El título del banner es obligatorio',
    imageRequired: 'Por favor suba la imagen del banner',
    linkUrlPlaceholder: 'Por favor ingrese la URL de enlace (opcional)',
    sortPlaceholder: 'Por favor ingrese el valor de ordenación, los números más pequeños aparecen primero',
    sortRequired: 'El valor de ordenación es obligatorio',
    remark: 'Observación',
    remarkPlaceholder: 'Por favor ingrese una observación',
    uploadImage: 'Subir Imagen',
    viewImage: 'Ver Imagen',
    removeImage: 'Eliminar Imagen',
    uploadTip: 'Tamaño recomendado: 1920x600px, admite formato JPG, PNG, tamaño de archivo no superior a 5MB',
    uploadImageOnly: 'Solo se pueden subir archivos de imagen',
    uploadSizeLimit: 'El tamaño de la imagen no puede exceder 5MB',
    uploadSuccess: 'Subida exitosa',
    uploadFailed: 'Error al subir',
    noImage: 'Sin imagen',
    deleteConfirm: '¿Está seguro de eliminar este banner?',
    deleteSuccess: 'Eliminado exitosamente',
    deleteFailed: 'Error al eliminar',
    saveSuccess: 'Guardado exitosamente',
    saveFailed: 'Error al guardar',
    updateSuccess: 'Actualizado exitosamente',
    updateFailed: 'Error al actualizar',
    getListFailed: 'Error al obtener la lista de banners'
  },

  // Consulta de Total de Agua
  waterTTL: {
    title: 'Consulta de Total de Agua',
    equipmentId: 'ID del Equipo',
    enterEquipmentId: 'Por favor ingrese el ID del equipo',
    organization: 'Organización',
    allOrganizations: 'Todas las Organizaciones',
    equipmentIdColumn: 'ID del Equipo',
    orgNameColumn: 'Organización',
    volumeTTLColumn: 'Volumen Total (ml)',
    waterRecord: 'Registro de Agua',
    export: 'Exportar',
    exportSuccess: 'Exportación exitosa',
    exportFailed: 'Error al exportar',
    getDataFailed: 'Error al obtener datos',
    getOrgListFailed: 'Error al obtener la lista de organizaciones'
  },

  // Gestión de Registros de Pago de WeChat
  payLog: {
    title: 'Gestión de Registros de Pago de WeChat',
    payLogTab: 'Registro de Pago',
    performanceTab: 'Monitor de Rendimiento',
    statisticsTab: 'Estadísticas',
    orderNo: 'Número de Pedido',
    orderNoPlaceholder: 'Por favor ingrese el número de pedido',
    logType: 'Tipo de Registro',
    allTypes: 'Todos',
    logTypePay: 'Pago',
    logTypeRefund: 'Reembolso',
    logTypeQuery: 'Consulta',
    logTypeCallback: 'Callback',
    logLevel: 'Nivel de Registro',
    allLevels: 'Todos',
    logLevelInfo: 'Información',
    logLevelWarn: 'Advertencia',
    logLevelError: 'Error',
    apiType: 'Tipo de API',
    apiTypeUnifiedOrder: 'Pedido Unificado',
    apiTypeQuery: 'Consultar Pedido',
    apiTypeRefund: 'Solicitar Reembolso',
    minDuration: 'Duración Mínima (ms)',
    maxDuration: 'Duración Máxima (ms)',
    startDate: 'Fecha de Inicio',
    endDate: 'Fecha de Fin',
    startDatePlaceholder: 'Fecha de Inicio',
    endDatePlaceholder: 'Fecha de Fin',
    viewDetail: 'Ver Detalle',
    export: 'Exportar',
    exportSuccess: 'Exportación exitosa',
    exportFailed: 'Error al exportar',
    dateRangeRequired: 'Por favor seleccione el rango de fechas',
    logDetail: 'Detalle del Registro',
    logContent: 'Contenido del Registro',
    requestData: 'Datos de Solicitud',
    responseData: 'Datos de Respuesta',
    errorMsg: 'Mensaje de Error',
    ipAddress: 'Dirección IP',
    createTime: 'Tiempo de Creación',
    duration: 'Duración (ms)',
    status: 'Estado',
    statDate: 'Fecha de Estadística',
    totalOrders: 'Total de Pedidos',
    successOrders: 'Pedidos Exitosos',
    failedOrders: 'Pedidos Fallidos',
    totalAmount: 'Monto Total (Yuan)',
    successAmount: 'Monto Exitoso (Yuan)',
    refundOrders: 'Pedidos de Reembolso',
    refundAmount: 'Monto de Reembolso (Yuan)',
    successRate: 'Tasa de Éxito',
    getDataFailed: 'Error al obtener datos'
  },

  // Configuración de Precio de Agua
  waterPriceConfig: {
    title: 'Configuración de Precio de Agua',
    configName: 'Nombre de Configuración',
    configNamePlaceholder: 'Por favor ingrese el nombre de configuración',
    configDesc: 'Descripción de Configuración',
    configDescPlaceholder: 'Por favor ingrese la descripción de configuración',
    waterVolume: 'Volumen de Agua (L)',
    waterVolumePlaceholder: 'Por favor ingrese el volumen de agua',
    basePrice: 'Precio Base (Yuan/L)',
    basePricePlaceholder: 'Por favor ingrese el precio base',
    discount: 'Descuento',
    discountPlaceholder: 'Por favor ingrese el descuento (0.01-1.00)',
    discountedUnitPrice: 'Precio Unitario con Descuento (Yuan/L)',
    finalPrice: 'Precio Final (Yuan)',
    sortOrder: 'Orden de Clasificación',
    sortOrderPlaceholder: 'Por favor ingrese el orden de clasificación',
    status: 'Estado',
    allStatus: 'Todos',
    enabled: 'Habilitado',
    disabled: 'Deshabilitado',
    enable: 'Habilitar',
    disable: 'Deshabilitar',
    createTime: 'Tiempo de Creación',
    updateTime: 'Tiempo de Actualización',
    createUser: 'Creador',
    updateUser: 'Actualizador',
    addConfig: 'Agregar Configuración',
    editConfig: 'Editar Configuración',
    batchEnable: 'Habilitar en Lote',
    batchDisable: 'Deshabilitar en Lote',
    waterVolumeRequired: 'Por favor ingrese el volumen de agua',
    waterVolumeMin: 'El volumen de agua debe ser mayor que 0',
    basePriceRequired: 'Por favor ingrese el precio base',
    basePriceMin: 'El precio base debe ser mayor o igual a 0',
    discountRequired: 'Por favor ingrese el descuento',
    discountRange: 'El descuento debe estar entre 0.01 y 1.00',
    configNameRequired: 'Por favor ingrese el nombre de configuración',
    deleteConfirm: '¿Está seguro de eliminar esta configuración?',
    deleteSuccess: 'Eliminación exitosa',
    deleteFailed: 'Error al eliminar',
    saveSuccess: 'Guardado exitoso',
    saveFailed: 'Error al guardar',
    updateSuccess: 'Actualización exitosa',
    updateFailed: 'Error al actualizar',
    statusChangeConfirm: '¿Está seguro de {status} esta configuración?',
    statusChangeSuccess: 'Actualización de estado exitosa',
    statusChangeFailed: 'Error al actualizar el estado',
    batchEnableConfirm: '¿Está seguro de habilitar en lote las configuraciones seleccionadas?',
    batchEnableSuccess: 'Habilitación en lote exitosa',
    batchEnableFailed: 'Error al habilitar en lote',
    batchDisableConfirm: '¿Está seguro de deshabilitar en lote las configuraciones seleccionadas?',
    batchDisableSuccess: 'Deshabilitación en lote exitosa',
    batchDisableFailed: 'Error al deshabilitar en lote',
    selectConfigs: 'Por favor seleccione las configuraciones para operar',
    getListFailed: 'Error al obtener la lista de configuraciones de precio'
  },

  // Configuración de Temperatura y Volumen de Agua
  waterConfig: {
    title: 'Configuración de Temperatura y Volumen de Agua',
    waterType: 'Tipo de Agua',
    allTypes: 'Todos',
    iceWater: 'Agua Helada',
    normalWater: 'Agua Normal',
    water45: 'Agua 45℃',
    water75: 'Agua 75℃',
    water95: 'Agua 95℃',
    status: 'Estado',
    allStatus: 'Todos',
    enabled: 'Habilitado',
    disabled: 'Deshabilitado',
    waterMl: 'Volumen (ml)',
    waterMlPlaceholder: 'Por favor ingrese el volumen',
    waterMlRequired: 'El volumen es obligatorio',
    sort: 'Ordenar',
    sortPlaceholder: 'Por favor ingrese el valor de ordenación (los números más pequeños aparecen primero)',
    typeName: 'Tipo de Agua',
    waterVolume: 'Volumen',
    createTime: 'Tiempo de Creación',
    updateTime: 'Tiempo de Actualización',
    addConfig: 'Agregar Configuración',
    editConfig: 'Editar Configuración de Temperatura y Volumen de Agua',
    addConfigTitle: 'Agregar Configuración de Temperatura y Volumen de Agua',
    typeRequired: 'El tipo de agua es obligatorio',
    duplicateError: '¡La combinación de tipo de agua y volumen ya existe!',
    deleteConfirm: '¿Está seguro de eliminar? ¡Esta acción no se puede deshacer!',
    statusConfirm: '¿Está seguro de {status} esta configuración?',
    deleteSuccess: 'Eliminado exitosamente',
    deleteFailed: 'Error al eliminar',
    saveSuccess: 'Guardado exitosamente',
    saveFailed: 'Error al guardar',
    statusUpdateSuccess: 'Estado actualizado exitosamente',
    statusUpdateFailed: 'Error al actualizar el estado',
    getDataFailed: 'Error al obtener datos'
  }
}
